import "./SinglePostTemplate.module.css"
import KurumsalKimlikBasligi from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import KurumsalAltBilgi from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <KurumsalKimlikBasligi />
      <SinglePostTemplate />
      <KurumsalAltBilgi />
    </div>
  )
}
